// import colorMode from './color-mode';

export default [
  // colorMode
];
